import type { JSX } from 'react'

// TODO: replace with new icons from Figma
export const FacebookSolidIcon = (): JSX.Element => (
  <use href='#facebookSolidIcon' height='100%' width='100%' />
)
